import { ChangeEvent } from "react";
import { HorizontalRadioPillsInput } from "../../../components/ui/button/v2/HorizontalRadioPillsInput";
import type { OptionNameValuePair } from "../../../lib/interfaces/types";
import { cn } from "../../../lib/utils";

export interface ControlReturnsCardProps {
  label: string;
  value?: boolean | null;
  remarks?: string | null;
  disabled?: boolean;
  onValueChange: (value: boolean) => void;
  onRemarksChange: (remarks: string) => void;
}

const CONTROL_RETURNS_OPTIONS: OptionNameValuePair<boolean>[] = [
  { name: "Yes", value: true },
  { name: "No", value: false },
];

const ControlReturnsCard = ({
  label,
  value,
  remarks,
  disabled,
  onValueChange,
  onRemarksChange,
}: ControlReturnsCardProps) => {
  const handleRemarksChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onRemarksChange(event.target.value);
  };

  const shouldShowRemarks = typeof value === "boolean";
  const isRemarksRequiredAndEmpty = value === true && !remarks?.trim();

  return (
    <div className="flex flex-col bg-white">
      <div className="flex items-center justify-between gap-2 py-3">
        <span className="flex-1 text-[16px] font-medium leading-[22px] font-[Inter] text-[#0A0A0A]">
          {label}
        </span>

        <HorizontalRadioPillsInput
          options={CONTROL_RETURNS_OPTIONS.map((opt) => ({ ...opt, disabled }))}
          selectedValue={value ?? undefined}
          onSelectionChange={onValueChange}
        />
      </div>

      {shouldShowRemarks && (
        <div className="flex flex-col pb-4">
          <textarea
            disabled={disabled}
            value={remarks ?? ""}
            onChange={handleRemarksChange}
            placeholder="Enter remarks..."
            className={cn(
              "w-full min-h-[95px] max-h-[300px] h-auto [field-sizing:content] resize-y overflow-y-auto rounded-[8px] bg-white px-3 py-2 text-[14px] font-normal font-[Inter] leading-5 text-[#0A0A0A] placeholder:text-[#737373] shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] outline-none disabled:bg-gray-50 disabled:cursor-not-allowed",
              isRemarksRequiredAndEmpty
                ? "border-[2px] border-[#C0C9FB]"
                : "border border-[#E5E5E5]"
            )}
          />
        </div>
      )}
    </div>
  );
};

export default ControlReturnsCard;